import type { FeedbackItemRef, ThreadSourceRef } from "../types";

export function buildThreadSourceRef(itemRef: FeedbackItemRef): ThreadSourceRef {
  return {
    type: "thread",
    workspace_id: itemRef.workspace_id,
    thread_id: itemRef.thread_id,
    assistant_message_index: itemRef.assistant_message_index,
  };
}
